import { Component } from '@angular/core';
import { NgClass } from '@angular/common';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-environment-banner',
  standalone: true,
  imports: [NgClass],
  templateUrl: './environment-banner.component.html',
  styleUrls: ['./environment-banner.component.scss'],
})
export class EnvironmentBannerComponent {
  showBanner = environment.showEnvironmentBanner;
  environmentName = environment.environmentName;
  bannerColor = environment.environmentBannerColor;
}
